<template>
<div>
  <div>
    <v-alert
      color="primary"
      text
    >
      <!-- {{ maintenanceMessage}} -->
      <h2>メンテナンスモード</h2>
      <div>現在メンテナンス中です。しばらくお待ちください。</div>

      <v-divider
        class="info my-6"
        style="opacity: 0.22;"
      >
      </v-divider>

      <div>
        <h4>{{ maintenanceMessage }}</h4>
      </div>
    </v-alert>

  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'maintenance',

  computed: {
    maintenanceMessage(): string {
      const message = process.env.VUE_APP_MAINTENANCE_MESSAGE;
      return message ? message : '';
    },
  }
})
</script>